import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Create a singleton MSAL instance to prevent multiple initializations
// Use a more specific key that includes the client ID to avoid conflicts
const instanceKey = `msalInstance_${msalConfig.auth.clientId}`;

let msalInstance: PublicClientApplication;

// Check if an instance already exists in the window
if ((window as any)[instanceKey]) {
  // Reuse existing instance
  msalInstance = (window as any)[instanceKey];
} else {
  // Create new instance and store it globally
  msalInstance = new PublicClientApplication(msalConfig);
  (window as any)[instanceKey] = msalInstance;
  
  // Initialize the MSAL instance only once
  msalInstance.initialize().catch((error) => {
    console.error("Failed to initialize MSAL:", error);
  });
}

export { msalInstance };